export const CONF_API_BE = {
  // API_MANAGEMENT_HOST: "https://k8s-be.eduprime.co.id/api/", //prod
  API_MANAGEMENT_HOST: process.env.REACT_APP_API_SISWA, //EndPoint with .enviroment
  // API_MANAGEMENT_HOST: "http://k8s-be-staging.eduprime.co.id/api/", //server-dev

  API_GET_PROVINSI: "getprovinsi",
  API_GET_KAB_KOTA: "kab_kota/",
  API_GET_SEKOLAH: "sekolah/",

  REPORT_SISWA_AKM: "akm/report/",

  SUCCESS_ERROR_CODE: "200",
  ID_ROLE_ADMIN_SEKOLAH: 9,
  ID_ROLE_GURU: 10,
};
